import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentsListPage } from "@/pages/Admin/legal/LegalDocumentsListPage";

export const Route = createFileRoute("/app/admin/legal/")({
  component: LegalDocumentsListPage,
});
